import { render, staticRenderFns } from "./EModalSelectMonthsTurma.vue?vue&type=template&id=0116c60c&scoped=true"
import script from "./EModalSelectMonthsTurma.vue?vue&type=script&lang=js"
export * from "./EModalSelectMonthsTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0116c60c",
  null
  
)

export default component.exports